import { colors, fonts } from '../../../theme';

const styles = (theme) => ({
  heading: {
    padding: 0,
    fontWeight: 600,
    color: colors.primary,
    paddingBottom: 20,
    fontSize: 18,
  },
  titleRow: {
    justifyContent: 'space-between',
    color: colors.actionIconsColor,
  },
  headerTitle: {
    fontWeight: fonts.fontWeight.bold,
    color: colors.black,
    fontSize: '1.5vw',
    padding: '10px 10px 10px 1px',
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
  },
  formCrossRow: {
    display: 'flex',
    justifyContent: 'left',
    marginTop: '4px',
    alignItems: 'center',
  },
  sidebar: {
    borderRight: `1px solid ${colors.border}`,
    '@media (max-width: 600px)': {
      width: 'auto',
    },
  },
  content: {
    width: '90%',
    '@media (max-width: 900px)': {
      width: '84%',
    },
  },

  contentCont: {
    minHeight: 300,
    border: `1px solid ${colors.border}`,
    margin: 30,
    '@media (max-width: 900px)': {
      margin: 0,
    },
    marginBottom: 50,
    marginTop: 0,
    borderRadius: 7,
    display: 'flex',
    '@media (max-width: 600px)': {
      display: 'flow-root',
    },
  },

  sectionTitleCont: {
    borderBottom: `1px solid ${colors.border}`,
    padding: 15,
    cursor: 'pointer',
  },

  sectionTitle: {
    fontWeight: 600,
    fontFamily: fonts.fontType.roboto,
    color: colors.black,
    fontSize: 12,
    cursor: 'pointer',
  },

  selectedSection: {
    boxShadow: `1px 1px 1px ${colors.border}`,
  },

  selectedSectionTitle: {
    color: colors.primary,
    fontSize: 12,
    cursor: 'pointer',
    fontWeight: 600,
    fontFamily: fonts.fontType.roboto,
  },

  assignmentBox: {
    minWidth: '100%',
    minHeight: '100%',
  },

  accordian: {
    '.MuiAccordion-root': {
      padding: 0,
    },
  },
  accodianSummary: {
    '.MuiAccordionSummary-content': {
      margin: 0,
    },
  },

  accordianDetails: {
    padding: '1px 1px 8px',
  },

  accordianItem: {
    borderBottom: `1px solid ${colors.border}`,
    borderTop: `1px solid ${colors.border}`,
  },
});

export default styles;
